export const style = {
  TableRow: {
    sx: {
      height: 350,
      width: 600,
    },
  },
  TableCell: {
    sx: {
      border: 0,
    },
  },
} as const;
